import * as t from "io-ts";

export const OnboardingStage = t.union([
  t.literal("ongoing"),
  t.literal("company_report_review"),
  t.literal("company_report_reviewed"),
  t.literal("director_report_review"),
  t.literal("director_report_reviewed"),
  t.literal("consumer_report_review"),
  t.literal("consumer_report_reviewed"),
  t.literal("owner_report_review"),
  t.literal("owner_report_reviewed"),
  t.literal("insurance_review"),
  t.literal("insurance_reviewed"),
  t.literal("trade_review"),
  t.literal("trade_reviewed"),
  t.literal("online_review"),
  t.literal("online_reviewed"),
  t.literal("fca_upload_review"),
  t.literal("fca_upload_reviewed"),
  t.literal("fca_awaiting_approval"),
  t.literal("fca_approved"),
  t.literal("onboarding_not_approved"),
]);

export type OnboardingStage =
  | "ongoing"
  | "company_report_review"
  | "company_report_reviewed"
  | "director_report_review"
  | "director_report_reviewed"
  | "consumer_report_review"
  | "consumer_report_reviewed"
  | "owner_report_review"
  | "owner_report_reviewed"
  | "insurance_review"
  | "insurance_reviewed"
  | "trade_review"
  | "trade_reviewed"
  | "online_review"
  | "online_reviewed"
  | "fca_upload_review"
  | "fca_upload_reviewed"
  | "fca_awaiting_approval"
  | "fca_approved"
  | "onboarding_not_approved";
